import api from '../http';
const key = 'public-competitions-v1';
let pending;
let requestNumber = 0;
export function loadPublicCompetitions() {
  try {
    localStorage.removeItem(key);
  } catch (_) { /* Storage is optional. */ }
  // A unique URL also bypasses responses cached under the old three-day policy.
  if (!pending) pending = api.get('rasspl/api/competitions/public', {
    params: { _fresh: `${Date.now()}-${++requestNumber}` },
  }).then(({ data }) => {
    const value = { ...data, days: data.days.map(day => {
      const date = new Date(day.date);
      return { ...day, image: day.imageVersion ? new URL(`rasspl/api/competitions/public/images/${day.imageVersion}/thumbnail.jpg`, api.defaults.baseURL).href : null, displayDate: date.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', timeZone: 'Africa/Johannesburg' }), yearLabel: date.toLocaleDateString('en-ZA', { year: 'numeric', timeZone: 'Africa/Johannesburg' }) };
    }) };
    return value;
  }).finally(() => { pending = null; });
  return pending;
}
